export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (window.location.hostname.includes("localhost")
    ? "http://localhost:5000"
    : "https://oneteamonegoal.onrender.com"); // ✅ your Render backend

export const apiUrl = (path) => `${API_BASE}${path}`;